import React from "react";
import { Box, Typography } from "@mui/material";

const ContentUnavailable = ({
    icon,
    title,
    description,
}) => {
    return (
        <Box
            sx={{
                width: "100%",
                height: "100%",
                mt: "-50px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: "center",
                    maxWidth: 500,
                    px: 3,
                }}
            >
                <Box sx={{ mb: 2, "& svg": { fontSize: 125 } }}>
                    {icon}
                </Box>

                <Typography
                    variant="h6"
                    sx={{ mb: 1 }}
                >
                    {title}
                </Typography>

                <Typography
                    variant="body2"
                    color="text.secondary"
                >
                    {description}
                </Typography>
            </Box>
        </Box>
    );
};

export default ContentUnavailable;